module.exports = __webpack_public_path__ + "img/pop-ph.f58f4ca8.jpg";